import { validate as isUuid } from 'uuid';
import { useEffect } from 'react';

let published = null;

/**
 * Tells the assistant which record a detail page is showing. Pass the loaded
 * record's own id, and nothing until it has loaded.
 *
 * @param {{ entity: string | null }} surface
 * @param {string|null|undefined} recordId
 */
export const useAssistantSurface = (surface, recordId) => {
    useEffect(() => {
        if (!surface?.entity || !recordId) return undefined;
        const entry = { surface: surface.entity, recordId };
        published = entry;
        return () => {
            if (published === entry) published = null;
        };
    }, [surface?.entity, recordId]);
};

// record.id is the entity UUID per the design contract; other ids are omitted.
/** @returns {{ surface: string, recordId?: string } | null} */
export const currentSurface = () => {
    if (!published) return null;
    const { surface, recordId } = published;
    return isUuid(recordId) ? { surface, recordId } : { surface };
};
